const disorders = [
    {
        "term": "Aichmophobia",
        "flavor text": "Sharp things make you uncomfortable. It's just a matter of time before someone cuts themselves.",
        "definition": "You cannot activate or depart with axes, swords, spears, daggers, scythes, or katars in your gear grid.",
        "expansion": "core"
    },
    {
        "term": "Anxiety",
        "flavor text": "You are afraid of being afraid. You're a nervous wreck, and monsters can smell this in your scent.",
        "definition": "At the start of each showdown, gain the priority target token unless you have stinky gear in your gear grid.",
        "expansion": "core"
    },
    {
        "term": "Apathetic",
        "flavor text": "You've given up. Nothing seems to matter. You have no concern for your own wellbeing.",
        "definition": "You cannot use or gain survival. You cannot gain courage. Cure this disorder if you have 8+ understanding.",
        "expansion": "core"
    },
    {
        "term": "Binge Eating",
        "flavor text": "Eating is the only thing that helps you escape your miserable life.",
        "definition": "You cannot depart unless you have consumable gear in your gear grid. You must consume if a choice to consume arises.",
        "expansion": "core"
    },
    {
        "term": "Coprolalia",
        "flavor text": "You have compulsive tics in the form of sporadic muttering, cursing, whimpering, and screaming.",
        "definition": "All your gear is noisy. You are always a threat unless you are knocked down, even if an effect says otherwise.",
        "expansion": "core"
    },
    {
        "term": "Fear of the Dark",
        "flavor text": "You cannot bear the oppressive darkness any longer",
        "definition": "You retire. If you gain this disorder during a hunt or showdown, you put on a brave face until you return to the settlement, vowing never to leave the Lantern Hoard again.",
        "expansion": "core"
    },
    {
        "term": "Hemophobia",
        "flavor text": "The mere sight of blood makes you lightheaded, and serious gore can knock you out!",
        "definition": "During the showdown, whenever a survivor (including you) gains a bleeding token, you are knocked down.",
        "expansion": "core"
    },
    {
        "term": "Hoarder",
        "flavor text": "You compulsively collect and stash anything you can get your hands on. Every little bit you add to your secret hoard makes your existence feel more real.",
        "definition": "Whenever you are a returning survivor, archive 1 resource gained from the last showdown and gain +1 courage.",
        "expansion": "core"
    },
    {
        "term": "Honorable",
        "flavor text": "You believe in honor and fairness when conducting yourself on the battlefield. It is these strong principles that have kept you alive, and you will not abandon them under any circumstances.",
        "definition": "You cannot attack a monster from its blind spot or if it is knocked down.",
        "expansion": "core"
    },
    {
        "term": "Hyperactive",
        "flavor text": "Whether you are running, fiddling with your gear, or pacing, you are always moving.",
        "definition": "During the showdown, you must move at least 1 space every round.",
        "expansion": "core"
    },
    {
        "term": "Immortal",
        "flavor text": "You are immortal! You will live forever and cannot be killed.",
        "definition": "While you are insane, convert all damage dealt to your hit locations to brain damage. You are so busy reveling in your own glory that you cannot spend survival while insane.",
        "expansion": "core"
    },
    {
        "term": "Indecision",
        "flavor text": "Past decisions haunt you ceaselessly. You are crippled by indecision, and even the most trivial choices grip you with terror.",
        "definition": "If you are the event revealer of hunt events that call on you to make a roll, roll twice and use the lower result.",
        "expansion": "core"
    },
    {
        "term": "Monster Panic",
        "flavor text": "Monsters make you feel bad. Really, really bad.",
        "definition": "Whenever you suffer brain damage from an intimidate action, suffer 1 additional brain damage.",
        "expansion": "core"
    },
    {
        "term": "Post-Traumatic Stress",
        "flavor text": "The last hunt was harrowing. All you can do is cower and relive the trauma. Only time can heal your wounds.",
        "definition": "Next settlement phase, you do not contribute or participate in any endeavors. Skip the next hunt to recover.",
        "expansion": "core"
    },
    {
        "term": "Prey",
        "flavor text": "You are prey. All there is for you is death.",
        "definition": "You may not spend survival unless you are insane.",
        "expansion": "core"
    },
    {
        "term": "Quixotic",
        "flavor text": "You carry the weight of your settlement on your shoulders. Everyone is counting on you to save them, and you will rise to the challenge.",
        "definition": "If you are insane when you depart, gain +1 survival and +1 strength token.",
        "expansion": "core"
    },
    {
        "term": "Rageholic",
        "flavor text": "Your rage boils out of control, causing you to see red at the slightest provocation.",
        "definition": "Whenever you suffer a severe injury, also suffer the frenzy brain trauma.",
        "expansion": "core"
    },
    {
        "term": "Secretive",
        "flavor text": "You love secrets. So much, in fact, that you pretend to have many.",
        "definition": "When you are a returning survivor, you quickly become preoccupied with your own affairs. You must skip the next hunt to deal with them.",
        "expansion": "core"
    },
    {
        "term": "Seizures",
        "flavor text": "Lingering damage from your head injuries has caused you to experience periods of uncontrollable shaking and absence of thought.",
        "definition": "During the showdown, whenever you suffer damage to your head location, you are knocked down.",
        "expansion": "core"
    },
    {
        "term": "Squeamish",
        "flavor text": "You can't handle bad smells.",
        "definition": "You cannot depart with any stinky gear in your gear grid. If a status or effect would cause you to become stinky, lose all your survival.",
        "expansion": "core"
    },
    {
        "term": "Traumatized",
        "flavor text": "Your experiences have left you shaken and paralyzed by fear.",
        "definition": "Whenever you end your act adjacent to a monster, you are knocked down.",
        "expansion": "core"
    },
    {
        "term": "Vestiphobia",
        "flavor text": "Even the lightest armor rubs harshly against your skin and constricts your ability to move.",
        "definition": "You cannot wear armor at the body location. If you are wearing armor at the body location when you gain this disorder, archive it as you tear it off your person!",
        "expansion": "core"
    },
    {
        "term": "Weak Spot",
        "flavor text": "You have an imaginary infirmity.",
        "definition": "When you gain this disorder, roll a random hit location and record it. You cannot depart unless you have armor at this hit location.",
        "expansion": "core"
    },
    {
        "term": "Dishonorable",
        "flavor text": "There is no high road.",
        "definition": "You cannot depart unless you are insane. Gain +1 speed while attacking a monster that is knocked down or from its blind spot.",
        "expansion": "Black Knight"
    },
    {
        "term": "Maladroit",
        "flavor text": "You are not sure-footed.",
        "definition": "When you end your movement on terrain, you are knocked down.",
        "expansion": "Black Knight"
    },
    {
        "term": "Ptophobia",
        "flavor text": "You are afraid to fall.",
        "definition": "When you suffer knockback, suffer monster level brain damage.",
        "expansion": "Black Knight"
    },
    {
        "term": "Arithmophilia",
        "flavor text": "You love numbers. Your life must exist in perfect arithmetical harmony.",
        "definition": "When you gain this disorder, roll 1d5. Your movement is that number. Ignore all other movement modifiers.",
        "expansion": "Dragon King"
    },
    {
        "term": "Destined",
        "flavor text": "You have a grand destiny that you must fulfill.",
        "definition": "If you do not depart, lose all survival and insanity.",
        "expansion": "Dragon King"
    },
    {
        "term": "Performance Anxiety",
        "flavor text": "You're not ready to love.",
        "definition": "You cannot be nominated for Intimacy. Cure this disorder if you have 8+ courage.",
        "expansion": "Dragon King"
    },
    {
        "term": "Superstitious",
        "flavor text": "Evil magic will be your undoing. You do not believe in abusing the other.",
        "definition": "You cannot activate or depart with other gear in your gear grid.",
        "expansion": "Dragon King"
    },
    {
        "term": "Motion Sickness",
        "flavor text": "Moving quickly makes you want to vomit.",
        "definition": "Whenever you would suffer knockback, gain 1 bleeding tokens instead.",
        "expansion": "Dung Beetle Knight"
    },
    {
        "term": "Vermin Obsession",
        "flavor text": "You love insects.",
        "definition": "While there is a Bug Patch terrain tile on the showdown board, you are so overwhelmed that you are doomed.",
        "expansion": "Dung Beetle Knight"
    },
    {
        "term": "Flower Addiction",
        "flavor text": "An insatiable hunger has bloomed in you, delicate and sickeningly sweet.",
        "definition": "You may only depart to hunt the Flower Knight. After you depart, cure this disorder.",
        "expansion": "Flower Knight"
    },
    {
        "term": "Ghostly Beauty",
        "flavor text": "You cannot experience fear if you do not exist.",
        "definition": "Double all insanity you gain. Double all survival you spend.",
        "expansion": "Flower Knight"
    },
    {
        "term": "Narcissistic",
        "flavor text": "There is nothing in the world more beautiful than yourself.",
        "definition": "You may not wear armor at the head location. If you are wearing armor at the head location when you gain this disorder, archive it.",
        "expansion": "Flower Knight"
    },
    {
        "term": "Chimeric Delusion",
        "flavor text": "You belong to the water.",
        "definition": "You cannot Depart to hunt the Frogdog. Your delusion prevents you from speaking. You cannot Encourage or participate in Intimacy.",
        "expansion": "Frogdog"
    },
    {
        "term": "Delirium",
        "flavor text": "Incoherent revelry overtakes you.",
        "definition": "All your gear is noisy. On Arrival, draw two random survivor attribute tokens, honoring the side they are drawn on.",
        "expansion": "Frogdog"
    },
    {
        "term": "Eproctophilia",
        "flavor text": "That's just nasty.",
        "definition": "When you gain a stink token, gain +1 insanity. You must depart with stinky gear in you gear grid.",
        "expansion": "Frogdog"
    },
    {
        "term": "Atelophobia",
        "flavor text": "You have an obsessive fear of imperfection.",
        "definition": "When there are no Perfect hits in your attack, suffer 1 brain damage.",
        "expansion": "Gamblers Chest"
    },
    {
        "term": "Ergophobia",
        "flavor text": "You cannot bear the thought of working. You hide away whenever you might be needed.",
        "definition": "When you are a returning survivor, you do not generate Endeavors. You cannot endeavor.",
        "expansion": "Gamblers Chest"
    },
    {
        "term": "Somniphobia",
        "flavor text": "You fear what might happen when you fall asleep away from home.",
        "definition": "On Arrival, lose half your survival, rounded down.",
        "expansion": "Gamblers Chest"
    },
    {
        "term": "Phobophobia",
        "flavor text": "You fear fear.",
        "definition": "At the start of your act, if you have 0 insanity, gain the Terrified survivor status card.",
        "expansion": "Crimson Crocodile"
    },
    {
        "term": "Bloodlust",
        "flavor text": "A single glimpse of red and that is all you can see.",
        "definition": "Whenever a survivor gains a bleeding token, suffer the frenzy disorder. Limit once per round.",
        "expansion": "Crimson Crocodile"
    },
    {
        "term": "Brain Smog",
        "flavor text": "You just cannot focus.",
        "definition": "You cannot Surge or Concentrate.",
        "expansion": "Smog Singers"
    },
    {
        "term": "Pacifist",
        "flavor text": "You refuse to fight.",
        "definition": "You cannot activate a weapon to attack. Ignore this if you are frenzied.",
        "expansion": "Smog Singers"
    },
    {
        "term": "Directional Dyslexia",
        "flavor text": "You have extreme difficulty distinguishing left from right and up from down.",
        "definition": "Your Movement can only be spent to move in a single straight line.",
        "expansion": "The King"
    },
    {
        "term": "Subjugated",
        "flavor text": "You are in awe of the majesty of monsters.",
        "definition": "When you are knocked down. you are dominated. When you depart to hunt the The King, remove this disorder.",
        "expansion": "The King"
    },
    {
        "term": "Schadenfreude",
        "flavor text": "You take pleasure in others' suffering.",
        "definition": "When another survivor suffers a severe injury, you are overcome with glee. You are knocked down and gain +1 insanity.",
        "expansion": "Atnas"
    },
    {
        "term": "Weltschmerz",
        "flavor text": "Things cannot be the way you wish them to be, and only death can shake you from you wallowing.",
        "definition": "You cannot depart unless you have updated the death count this lantern year.",
        "expansion": "Atnas"
    },
    {
        "term": "Absent Seizures",
        "flavor text": "No one knows where your mind goes when you're gone, not even you.",
        "definition": "The first time you would suffer a brain trauma each showdown, you are instead knocked down and forget a fighting art (erase it).",
        "expansion": "Gorm"
    },
    {
        "term": "Megalophobia",
        "flavor text": "Even large, looming shadows make you jumpy.",
        "definition": "You may not depart for hunts or showdowns with monsters that occupy more than 4 spaces on the showdown board.",
        "expansion": "Gorm"
    },
    {
        "term": "Delicious",
        "flavor text": "Predators of all shapes and sizes find your scent irresistible.",
        "definition": "You are still considered a threat when you are knocked down (unless you use an effect that says otherwise).",
        "expansion": "Lion God"
    },
    {
        "term": "Enfeebled",
        "flavor text": "You are a delicate flower, wilting in the darkness.",
        "definition": "It takes one less bleeding token to kill you.",
        "expansion": "Lion God"
    },
    {
        "term": "Stark Raving",
        "flavor text": "Freedom awaits those pushed this far beyond the breaking point.",
        "definition": "You are always insane, regardless of your insanity.",
        "expansion": "Lion God"
    },
    {
        "term": "Tunnel Vision",
        "flavor text": "If you're not killing something, you're wasting your time.",
        "definition": "When you spend Activation, you may only activate weapons.",
        "expansion": "Lion God"
    },
    {
        "term": "Prima Donna",
        "flavor text": "The double-edged sword of fame is the only weapon you require.",
        "definition": "Each survivor turn, you must take your act first (roll off each turn if multiple survivors have this disorder).",
        "expansion": "Lion Knight"
    },
    {
        "term": "Shallow Lungs",
        "flavor text": "Yelling makes you feel light-headed.",
        "definition": "When you encourage, you are knocked down.",
        "expansion": "Lion Knight"
    },
    {
        "term": "Stage Fright",
        "flavor text": "You hate being the center of attention.",
        "definition": "Whenever you become doomed or gain the priority target token, lose 1 survival.",
        "expansion": "Lion Knight"
    },
    {
        "term": "Unlucky",
        "flavor text": "Your mother always said you were born under a bad sign.",
        "definition": "You cannot critically wound.",
        "expansion": "Lion Knight"
    },
    {
        "term": "Hyper-Sensitivity",
        "flavor text": "Your will to survive has become indefatigable.",
        "definition": "You may dodge one additional time per round. Whenever you are hit by an attack, you must dodge at least once, if possible.",
        "expansion": "Slenderman"
    },
    {
        "term": "Spiral Ganglia",
        "flavor text": "The roads in your mind cross and reveal a strange new path.",
        "definition": "At the start of the showdown, gain the Darkness Awareness survivor status card.",
        "expansion": "Slenderman"
    },
    {
        "term": "Controlophobia",
        "flavor text": "You are deeply afraid of being the monster controller.",
        "definition": "While you are the monster controller, double any damage you suffer.",
        "expansion": "Spidicules"
    },
    {
        "term": "Revenge",
        "flavor text": "When a fellow hunter perishes, you lose control.",
        "definition": "When a survivor dies during the showdown, suffer the Frenzy brain trauma.",
        "expansion": "Spidicules"
    },
    {
        "term": "Tiny Arachnophobia",
        "flavor text": "You are irrationally scared by tiny spiders and the things they produce.",
        "definition": "You cannot carry any gear with the amber keyword. You cannot gain any resources with the silk keyword.",
        "expansion": "Spidicules"
    },
    {
        "term": "Emotionless",
        "flavor text": "You don't have any emotions. You've hidden this from everyone by mimicking their social interactions.",
        "definition": "You cannot gain +1 strength tokens.",
        "expansion": "Sunstalker"
    },
    {
        "term": "Overprotective",
        "flavor text": "You love the feeling of being needed.",
        "definition": "When an adjacent survivor is knocked down, you are also knocked down as you rush to their aid.",
        "expansion": "Sunstalker"
    },
    {
        "term": "Sun-Drunk",
        "flavor text": "When your emotions rise, you can only think of violence.",
        "definition": "When you have any +1 strength tokens, you cannot dash, dodge or Story Event Run Away.",
        "expansion": "Sunstalker"
    },
];


export default disorders;